import { FC } from "react";

import Box from "@mui/material/Box";

interface NewsletterMirrorFrameProps {
  html: string | undefined;
  title: string;
}

export const NewsletterMirrorFrame: FC<NewsletterMirrorFrameProps> = ({ html, title }) => (
  <Box
    component="iframe"
    title={title}
    srcDoc={html}
    sandbox="allow-popups allow-popups-to-escape-sandbox"
    sx={{ border: "none", width: "100%", height: "100%", display: "block" }}
    data-test="newsletter-mirror-frame"
  />
);
